import { PropsWithChildren, ReactNode } from 'react';
import Square from '../../objects/Square';
import './styles.css';

// Declaring type of props - see "Typing Component Props" for more examples
type BoardProps = {
}; /* use `interface` if exporting so that consumers can extend */

const Board = ( props:  BoardProps): JSX.Element =>  {
	return (
		<div className='table'>
			<ul className='grid'>
			    <li className='grid-item'>
			    	<Square mark='x'/>
			    </li>
		        <li className='grid-item'>
		        	<Square mark='o'/>
		        </li>
		        <li className='grid-item'>
		        	<Square />
		        </li>
		        <li className='grid-item'>
		        	<Square mark='x'/>
		        </li>
		        <li className='grid-item'>
		        	<Square />
		        </li>
		        <li className='grid-item'>
		        	<Square mark='o'/>        
		        </li>
		        <li className='grid-item'>
		        	<Square />
		        </li>
		        <li className='grid-item'>
		        	<Square mark='x'/>
		        </li>
		        <li className='grid-item'>
		        	<Square mark='x'/>
		        </li>
	        </ul>
		</div>
	);
}

export default Board;